import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

const FAIL_REASONS = [
  "Background Removal",
  "Not Cropped",
  "Missed Instructions",
  "Bad Resolution Quality",
  "Incorrect Size",
  "Incorrect Line Item",
  "Incorrect Quantity",
  "Needs Further Art Repair",
  "Art Requires HT dots",
  "Details too small for print",
  "Other"
];

const FailReasonDialog = ({ isOpen, onDialogClose, onDialogSubmit }) => {
  const [failReason, setFailReason] = useState(null);
  const [otherReasonDetails, setOtherReasonDetails] = useState(null);

  const handleReasonChange = event => {
    setOtherReasonDetails(null);
    setFailReason(event.target.value);
  };

  const handleDialogClose = () => {
    setFailReason(null);
    setOtherReasonDetails(null);
    onDialogClose();
  };

  const handleDialogSubmit = () => {
    onDialogSubmit({ reason: failReason, details: otherReasonDetails });
    handleDialogClose();
  };

  const isOtherReasonSelected =
    failReason === FAIL_REASONS[FAIL_REASONS.length - 1];

  return (
    <Dialog maxWidth="sm" open={isOpen} onClose={handleReasonChange}>
      <DialogTitle>Choose the reason</DialogTitle>
      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel htmlFor="failReason">Reason</InputLabel>
          <Select
            id="failReason"
            value={failReason}
            onChange={handleReasonChange}
            label="Reason"
          >
            {FAIL_REASONS.map((reason, index) => (
              <MenuItem key={index} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </Select>
          {isOtherReasonSelected && (
            <TextField
              autoComplete="off"
              fullWidth
              label="Details"
              size="small"
              multiline
              style={{ marginTop: "20px" }}
              onChange={event => {
                setOtherReasonDetails(event.target.value);
              }}
              value={otherReasonDetails}
              variant="outlined"
              minRows={3}
            />
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose} color="error">
          Close
        </Button>
        <Button
          onClick={handleDialogSubmit}
          color="primary"
          disabled={
            failReason === null ||
            (isOtherReasonSelected && otherReasonDetails === null)
          }
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FailReasonDialog;
